import { SideMenuGroup } from '../SideMenu';

/**
 * The institutional pages, grouped the way a shopper reads them rather than in the flat
 * list the legacy sidebar used.
 *
 * Hardcoded on purpose. These are fourteen fixed pages, none of them editable anywhere,
 * and the same list is already hardcoded in the footer and the mobile "About Us" panel —
 * a table would add a deploy-time dependency without removing one.
 *
 * Every href is a standardised slug, and the slugs are PageRegistry's: the server marks an
 * entry current by comparing its path against `activePath`, which PageController's registry
 * supplies, so a path spelled differently here is not a broken link — the old urls all 301 —
 * but it is an entry that can never be highlighted. Change one here and change it there.
 *
 * `/help` is the exception and is still not PageRegistry's: on DiscountMags it is the help
 * centre, rendered by HelpCenterController from Kustomer's knowledge base, because it takes
 * a slug out of the url. It is `activePath` that has to agree, and it does -- the controller
 * passes '/help'. The other brands use that slug for their own FAQ page, which is a
 * PageRegistry entry, and their menus keep saying "FAQs".
 *
 * Paths are relative because the AU and IN sites serve from a base directory; every one
 * of them goes through buildUrl before it is rendered.
 */
export const INSTITUTIONAL_MENU: SideMenuGroup[] = [
  {
    title: 'Shop with Confidence',
    items: [
      { label: 'Our Guarantee', href: '/guarantee' },
      { label: 'DiscountLock', href: '/discountlock' },
      { label: 'Reviews', href: '/reviews' },
      { label: 'Valid Payment Methods', href: '/payment-methods' },
    ],
  },
  {
    title: 'Policies',
    items: [
      { label: 'Refund Policy', href: '/refund-policy' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Use', href: '/terms' },
      { label: 'Accessibility', href: '/accessibility' },
      { label: 'Copyright & Notices', href: '/copyright' },
    ],
  },
  {
    title: 'Support',
    items: [
      { label: 'Help Center', href: '/help' },
      { label: 'Shipping & Delivery', href: '/shipping' },
      { label: 'Contact Us', href: '/contact' },
      { label: 'About Us', href: '/about-us' },
      { label: 'Affiliate Program', href: '/affiliate-program' },
    ],
  },
];
